import React, { useContext, useEffect, useState } from 'react';
import { DragDropContext } from 'react-beautiful-dnd';
import { ColumnBoard } from '../../components';
import boardFormats from '../../config/boardFormats';
import { updateCard, combineCards } from '../../services/cards';
import { GlobalContext } from '../../context/GlobalState';
import { getRankOnMove, getRankOnReorder } from '../../utils/rankCard';
import { logEvent, TrackingEvents } from '../../tracking';

function isCustomFormat(format) {
  return (
    format &&
    (format.value === 'Custom' ||
      format.id === 'Custom' ||
      format.type === 'Custom')
  );
}

function CardsBoard() {
  const [columns, setColumns] = useState([]);
  const {
    cards,
    retrospective,
    currentRetrospectiveId,
    onCombineCards,
    onReorderCards,
    onMoveCards,
  } = useContext(GlobalContext);

  useEffect(() => {
    const format = boardFormats.find(
      (item) => item.id === retrospective.format
    );

    if (retrospective.customFormat || isCustomFormat(format)) {
      setColumns(
        retrospective.customFormat.map(({ columnName }) => columnName)
      );
    } else {
      setColumns(format.columns);
    }
  }, [retrospective.customFormat, retrospective.format]);

  const onDragEnd = (result) => {
    const { source, destination, combine, draggableId } = result;
    if (!destination && !combine) return;

    if (combine) {
      logEvent(TrackingEvents.GROUP_CARDS);
      const originCard = cards.find((item) => item.id === draggableId);
      const destinationCard = cards.find(
        (item) => item.id === combine.draggableId
      );
      const updatedDescription = `${destinationCard.description}\n\n${originCard.description}`;

      onCombineCards(originCard.id, destinationCard.id, updatedDescription);
      combineCards(
        currentRetrospectiveId,
        draggableId,
        combine.draggableId,
        updatedDescription
      );
      return;
    }
    logEvent(TrackingEvents.REORDER_CARD);

    if (source.droppableId === destination.droppableId) {
      if (source.index === destination.index) return;
      const columnCards = cards.filter(
        (card) => card.columnName === source.droppableId
      );
      const rank = getRankOnReorder(columnCards, source, destination);
      const card = columnCards[source.index];

      onReorderCards(source, destination);
      updateCard(currentRetrospectiveId, card.id, { rank });
    } else {
      const sourceColumnCards = cards.filter(
        (card) => card.columnName === source.droppableId
      );
      const card = sourceColumnCards[source.index];
      const rank = getRankOnMove(cards, destination);

      onMoveCards(source, destination);
      updateCard(currentRetrospectiveId, card.id, {
        rank,
        columnName: destination.droppableId,
      });
    }
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      {columns.map((column) => {
        return <ColumnBoard key={column} column={column} />;
      })}
    </DragDropContext>
  );
}

export default CardsBoard;
